// extracted by mini-css-extract-plugin
module.exports = {"modalHeaderContainer":"styles_modalHeaderContainer__3pe94","modalContentContainer":"styles_modalContentContainer__26uz-"};